<template>
  <div
    class="sofa-card"
    :class="`${ isActive? 'active' :'' } ${type}`"
    @click="$emit('click')"
    :key="option.title"
  >
    <div class="sofa-card--thumb">
      <AppImage :lazy-src="imageUrl" />
    </div>
    <div class="sofa-card--footer">
      <div class="sofa-card--name">
        <span class="sofa-card--name--bolded">{{ boldedTitle }}</span>
        {{ regularTitle }}
      </div>
    </div>

    <div
      v-if="backorderString"
      class="sofa-card--backorder"
    >
      {{backorderString}}
    </div>
  </div>
</template>
<script>
import AppImage from "./AppImage.vue";
export default {
  name: "ImageOptionCardFabric",
  props: {
    option: Object,
    isActive: Boolean,
    type: String,
  },
  data() {
    return {
      imageUrl: this.setOptionImage(),
    };
  },
  computed: {
    boldedTitle() {
      return this.option.title.split(' ')[0]
    },
    regularTitle() {
      return this.option.title.split(' ')[1]
    },
    backorderString() {
      if (this.option.backorder_date) {
        const date = new Date(this.option.backorder_date)
        return `In Stock ${[`${date.getUTCMonth() + 1}`.padStart(2,'0'),`${date.getUTCDate()}`.padStart(2,'0')].join('/')}`
      }
      return '' 
    }
  },
  components: {
    AppImage,
  },
  methods: {
    setOptionImage() {
      if (this.option.image_url) {
        return this.processURL("_80x80");
      }
      return "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081";
    },
    processURL(processingString) {
      let fileExtension = ".JPG";
      if (this.option.image_url.match(/(.jpg)/)) {
        fileExtension = ".jpg";
      }
      if (!this.option.image_url.includes(processingString)) {
        return this.option.image_url.replace(
          /(.jpg)/i,
          `${processingString}${fileExtension}`
        );
      }
      return this.option.image_url;
    },
  },
};
</script>
<style scoped>
.sofa-card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  cursor: pointer;
  /* width: calc(33% - 14px); */
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: 0.2s ease;
  position: relative;
}
/* @media screen and (min-width: 768px) {
  .sofa-card {
    width: 94px;
  }
} */
.sofa-card--name {
  font-size: 9px;
  line-height: 140%;
  user-select: none;
  font-weight: 500;
  text-transform: uppercase;
}
.sofa-card--name--bolded {
  font-weight: 900;
}
@media screen and (min-width: 768px) {
  .sofa-card--thumb {
    height: 90px;
  }
}
.sofa-card--thumb img {
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.sofa-card--thumb {
  overflow: hidden;
  flex-grow: 0;
  flex-shrink: 0;
  height: 70px;
}
.sofa-card--footer {
  padding: 5px 7px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  color: #3a3830;
}
.sofa-card.leg .sofa-card--thumb img {
  width: 100%;
  height: 100%;
  max-height: unset;
  max-width: unset;
}
.sofa-card.active {
  background: #7E8772;
}
.sofa-card.active  .sofa-card--footer {
  color: #fff;
}
.sofa-card--backorder {
  font-size: 8px;
  text-transform: uppercase;
  color: #fff;
  display: flex;
  justify-content: center;
  padding: 4px 6px;
  margin-right: 5px;
  border-radius: 0 5px 5px 0;
  background-color: #31382D;
  position: absolute;
  top: 10px;
  text-align: left;
}
.sofa-card.active .sofa-card--thumb {
  border: 0;
}
</style>
